var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("cargo-advance-select", {
        attrs: {
          disabled: _vm.disabled,
          "select-type": _vm.selectTypeNames.basic_data_Department,
          filterable: "",
          "default-value": _vm.departmentId || "",
          "method-params": _vm.methodParams,
          placeholder: _vm.placeholder
        },
        on: {
          parentCallBack: function(p) {
            _vm.$emit("change", p)
          }
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }